export const sidenavTokens = {
  FontColorBaseDefault: '#1A1A1A',
  TransitionCurveBaseDefault: 'cubic-bezier(0, 0.405, 0, 1)',
  TransitionDurationBaseDefault: '0.5s',
  GroupToggleFontLeadingBaseDefault: '24px',
  GroupItemPaddingBaseHorizontal: '16px',
  GroupItemPaddingRightVisibleFocus: '10px',
  GroupItemMarginRightVisibleFocus: '10px',
  GroupItemBorderRadiusVisibleFocus: '4px',
  GroupItemFontWeightBaseDefault: '400',
  GroupItemFontWeightBaseActive: '600',
  GroupItemPaddingLeftLevel0: '20px',
  GroupItemPaddingLeftLevel1: '32px',
  GroupItemPaddingLeftLevel2: '44px',
  IconBorderRadiusBaseDefault: '4px',
  IconMarginRightBaseOpen: '10px',
  IconBackgroundColorActiveDefault: '#E2D5C2',
  IconBadgePositionTopBaseDefault: '-1px',
  IconBadgePositionRightBaseDefault: '-1px',
  IconBadgeDimensionBaseDefault: '8px',
  IconBadgeBackgroundColorBaseDefault: '#EA957B',
  IconBadgeBorderRadiusBaseDefault: '4px',
  ItemBackgroundColorActiveDefault: '#FFFFFF',
  ItemBackgroundColorActiveHover: '#F0EAE1',
  ItemSpacingPaddingVerticalBaseDefault: '22px',
  ItemSpacingPaddingHorizontalBaseDefault: '16px',
  ItemPaddingLeftLevel0: '20px',
  ItemPaddingLeftLevel1: '32px',
  ItemPaddingLeftLevel2: '44px',
  ItemPaddingLeftActiveLevel0: '16px',
  ItemPaddingLeftActiveLevel1: '28px',
  ItemPaddingLeftActiveLevel2: '40px',
  ItemBorderStyleBaseDefault: 'solid',
  ItemBorderWidthBaseDown: '4px',
  ItemBorderColorBaseDown: '#FF7C55',
  ItemPaddingBaseOpenVertical: '8px',
  ItemFontSizeBaseDefault: '14px',
  ItemFontLeadingBaseDefault: '24px',
  TwiddleFontColorBaseDefault: '#1A1A1A',
  TwiddleFontColorBaseHover: '#1A1A1A',
  NewTabFontColorBaseDefault: '#1A1A1A',
  WrapperColorBackgroundBaseDefault: '#FBF8F7',
  WrapperWidthBaseClosed: '60px',
  WrapperWidthBaseOpen: '240px',
  WrapperWidthMobileOpen: 'calc(100vw)',
  WrapperPaddingTopBaseOpen: '8px',
  WrapperPaddingBottomBaseDefault: '56px',
  WrapperPaddingLeftBaseDefault: '16px',
  WrapperPaddingRightBaseDefault: '16px',
  WrapperElevationCompactDefault: '21',
} as const;
